// IMAGE prop

import React from "react";
import '../styles/global.css'

export default function FullWidthImage(props) {
    return  (
        
        <div class="container bannerWidth noPadding">
        
            <div class="row">
        
                <div class="col-10 offset-1 col-xl-12 offset-xl-0 bannerBlock" id={props.id}>
        
                    <img loading="lazy" src={props.src} alt={props.alt} width="100%"></img>
        
                </div>        
        
            </div>
        
        </div>
        
    );
    
}


//class="col-12 col-xl-10 offset-xl-1"
//<div class={props.elementClass}>